import { render, staticRenderFns } from "./TelefoneBase.vue?vue&type=template&id=5486c58c"
import script from "./TelefoneBase.vue?vue&type=script&lang=js"
export * from "./TelefoneBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports